module.exports = __webpack_public_path__ + "img/topping.3eed12df.png";